import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, success, deleteData } from "../../components/messageBox";
import * as types from "../../constants/actionTypes";
import moment from "moment";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST } from "../../service/api";
import { Header } from "../../constants/headers";

const getStateModulePasien = (state) => state.ModulePasien;

export function* postForm(params) {
  try {
    yield put({ type: types.MODULE_PASIEN_SET_LOADER, value: true });

    let stateModulePasien = yield select(getStateModulePasien);
    const _body = stateModulePasien.formPasien;
    let body = {
      f_id_pasien: _body.id_pasien,
      f_date_register: _body.date_register,
      f_nama_pasien: _body.nama_pasien,
      f_telepon_pasien: _body.telepon_pasien,
      f_tgl_lahir: moment(_body.tgl_lahir).format("YYYY-MM-DD"),
      f_jenis_kelamin: _body.jenis_kelamin,
      f_no_identitas: _body.no_identitas,
      f_golongan_darah: _body.golongan_darah,
      f_status_perokok: _body.status_perokok,
      f_no_alamat_pasien: _body.no_alamat_pasien,
      f_catatan: _body.catatan,
      f_email_user: _body.email_user,
      f_id_negara: _body.id_negara,
      f_id_provinsi: _body.temp_lokasi[0],
      f_id_kabupaten: _body.temp_lokasi[1],
      f_id_kecamatan: _body.temp_lokasi[2],
      f_id_desa: _body.temp_lokasi[3],
      f_id_kesehatan_pasien: _body.id_kesehatan_pasien,
    };

    if (!params.value) {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_PASIEN_CREATE_POST, body, { headers: Header() });
      if (response.acknowledge == 1) {
        yield put({ type: types.MODULE_PASIEN_SET_LOADER, value: false });
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    } else {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_PASIEN_UPDATE_POST, { ...body, id: params.value }, { headers: Header() });
      if (response.acknowledge == 1) {
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    }

    yield put({ type: types.MODULE_PASIEN_SET_LOADER, value: false });
  } catch (error) {
    yield put({ type: types.MODULE_PASIEN_SET_LOADER, value: false });
    messages("Error", error, "error", false, false);
  }
}

export function* getMasterData() {
  try {
    yield put({ type: types.MODULE_PASIEN_SET_LOADER, value: true });

    let _body = {
      MasterData: [
        {
          ObjectName: "listJenisKelamin",
        },
        {
          ObjectName: "listNegara",
        },
      ],
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.GET_LIST_MASTER_DATA, _body);
    yield all(
      yield put({ type: types.MODULE_PASIEN_MASTER_DATA_SUCCESS, property: "listJenisKelamin", value: response.data.listJenisKelamin }),
      yield put({ type: types.MODULE_PASIEN_MASTER_DATA_SUCCESS, property: "listNegara", value: response.data.listNegara })
    );
    yield put({ type: types.MODULE_PASIEN_SET_LOADER, value: false });
  } catch (error) {
    yield put({ type: types.MODULE_PASIEN_SET_LOADER, value: false });
    messages("Error", error, "error", false, false);
  }
}

export function* getDataPasien(params) {
  try {
    yield put({ type: types.MODULE_PASIEN_SET_LOADER, value: true });

    if (params.value == "all") {
      const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_PASIEN_LIST_GET);

      if (response.acknowledge == 1) {
        yield put({ type: types.MODULE_PASIEN_DATA_GET_ALL_SUCCESS, value: response.data });
      } else {
        messages("Error", "Gagal memuat data", "error", false, false);
      }
    } else if (params.value >= 0) {
      const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_PASIEN_DETAIL_GET + params.value);

      if (response.acknowledge == 1) {
        let _formEdit = {
          id_pasien: response.data.f_id_pasien,
          date_register: response.data.f_date_register,
          nama_pasien: response.data.f_nama_pasien,
          telepon_pasien: response.data.f_telepon_pasien,
          tgl_lahir: response.data.f_tgl_lahir,
          jenis_kelamin: response.data.f_jenis_kelamin,
          no_identitas: response.data.f_no_identitas,
          golongan_darah: response.data.f_golongan_darah,
          status_perokok: response.data.f_status_perokok,
          no_alamat_pasien: response.data.f_no_alamat_pasien,
          catatan: response.data.f_catatan,
          email_user: response.data.f_email_user,
          id_negara: response.data.f_id_negara,
          temp_lokasi: [response.data.f_id_provinsi, response.data.f_id_kabupaten, response.data.f_id_kecamatan, response.data.f_id_desa],
          id_kesehatan_pasien: response.data.f_id_kesehatan_pasien,
        };

        yield put({ type: types.MODULE_PASIEN_DATA_GET_DETAIL_SUCCESS, payload: _formEdit });
      } else {
        messages("Error", "Gagal memuat data", "error", false, false);
      }
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }
    yield put({ type: types.MODULE_PASIEN_SET_LOADER, value: false });
  } catch (error) {
    yield put({ type: types.MODULE_PASIEN_SET_LOADER, value: false });
    messages("Error", error, "error", false, false);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(types.MODULE_PASIEN_SUBMIT_FORM, postForm), takeLatest(types.MODULE_PASIEN_MASTER_DATA, getMasterData), takeLatest(types.MODULE_PASIEN_DATA_GET, getDataPasien)]);
}
